import React, { useState } from "react";
import {
  MainContainer,
  InnerNavbar,
  Navbar,
  NavLink,
  CardTitle,
} from "../../styles.js";
import { Helmet } from "react-helmet";
import firebase from "firebase";
import "firebase/firestore";
import { SubmitForm, InnerForm, IdeaInput } from "./styles";
import navlinks from "../../Constants/Navbar";
import SubmitButton from "../../Components/SubmitButton";
import { Redirect, Link } from "react-router-dom/cjs/react-router-dom.min";
const db = firebase.firestore();

export default () => {
  const [titleInputValue, setTitleInputValue] = useState("");
  const [nameInputValue, setNameInputValue] = useState("");
  const [descriptionInputValue, setDescriptionInputValue] = useState("");
  const [linkInputValue, setLinkInputValue] = useState("");

  function submitIdea() {
    db.collection("Submissions")
      .doc()
      .set(
        {
          Author: nameInputValue,
          Title: titleInputValue,
          Description: descriptionInputValue,
          Link: linkInputValue,
          Points: 0,
          Time: Date.now(),
        },
        console.log("Success!")
      )
      .catch(function (error) {
        console.error("Error writing document: ", error);
      });
    successText();
  }

  const successText = () => {
    return <Redirect to="/home"></Redirect>;
  };
  return (
    <MainContainer>
      <Helmet>
        <title>Covid Thinkspace - Submit</title>
      </Helmet>
      <Navbar>
        <InnerNavbar>
          {navlinks.map((btn) => (
            <NavLink to={btn.url}>{btn.label}</NavLink>
          ))}
        </InnerNavbar>
      </Navbar>
      <SubmitForm>
        <InnerForm>
          <CardTitle>Submit your Idea</CardTitle>
          <br></br>
          <IdeaInput
            onChange={(e) => setNameInputValue(e.target.value)}
            value={nameInputValue}
            placeholder="Your Name"
          ></IdeaInput>
          <IdeaInput
            onChange={(e) => setTitleInputValue(e.target.value)}
            value={titleInputValue}
            placeholder="Title"
          ></IdeaInput>
          <IdeaInput
            onChange={(e) => setDescriptionInputValue(e.target.value)}
            value={descriptionInputValue}
            placeholder="Description"
          ></IdeaInput>
          <IdeaInput
            onChange={(e) => setLinkInputValue(e.target.value)}
            value={linkInputValue}
            placeholder="Link to Project (repository, code, etc.)"
          ></IdeaInput>
          <Link to="/">
            <SubmitButton onClick={submitIdea}>Submit</SubmitButton>
          </Link>
        </InnerForm>
      </SubmitForm>
    </MainContainer>
  );
};
